import * as React from 'react';
import { useEffect } from 'react';
import myProfilePhoto from '../../../../assets/images/messages/my_profile.png';
import { AnimatePresence, motion } from "framer-motion"
import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';
import videoPlayerImage from '../../../../assets/images//videoPlayer.png';

import { useNavigate } from 'react-router-dom';
import useClickOutside from '../../../../Hooks/useClickOutside';
import { useState } from 'react';
import { useRef } from 'react';
import { VoiceRecorder } from '../../../../Pages/Home/Posts/VoiceRecorder/VoiceRecorder';
import { AudioPlayer } from '../../../AudioPlayer/AudioPlayer';
import { useDropzone } from 'react-dropzone';
import { PostGrid } from '../../../PostGrid/PostGrid';
import { PreviewCarousel } from '../../../PreviewCarousel/PreviewCarousel';
import { GIFs } from '../../../../Pages/Home/Posts/GIFs/GIFs';

export interface IMessageInboxProps {
    setInboxMessagesShow: Function,
    inboxMessages: {
        id: number,
        profilePhoto: string,
        profileName: string,
        messageText?: string,
        messagePhotoVideo?: {
            source: string,
            isVideo?: boolean,
            isVideoPlayOnPost?: boolean,
            videoSrc?: string,
            id: number,
        }[],
        messageGifs?: string,
        messageAudio?: string,

        messageSentTime: string,
        isItMyMessage: boolean,
    }[],

}

export function MessageInbox(props: IMessageInboxProps) {
    const [realtimeMessages, setRealtimeMessages] = React.useState(props.inboxMessages)
    const navigate = useNavigate()

    const [moreAssetsOpen, setMoreAssetsOpen] = React.useState(false);
    const moreAssetsRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(moreAssetsRef, () => setMoreAssetsOpen(false))


    useEffect(() => {
        const messageInputBox = document.getElementById('messageWriteInput') as HTMLInputElement;
        const messages_box = document.getElementById("messagesBox")
        // messages_box?.scrollTo({
        //     top: -0,
        //     behavior: 'smooth'
        // })
        messageInputBox.focus()
        messages_box?.scrollTo(0, messages_box.scrollHeight);
    }, [realtimeMessages])


    // console.log(realtimeMessages);




    // handle send btn show and textarea height increase
    const [realTimeInputAndFilesValue, setRealTimeInputAndFilesValue] = useState({
        textOrEmoji: '',
        files: null,
    })
    const commentWriteBox: any = (document.getElementById(`messageWriteInput`) as HTMLDivElement);

    useEffect(() => {
        if (realTimeInputAndFilesValue.textOrEmoji.length > 0 && realTimeInputAndFilesValue.textOrEmoji.replace(/\s/g, "").length) {
            setIsSendBtnOpen(true)
            autoIncraseHeight(commentWriteBox)
        } else {
            if (realTimeInputAndFilesValue.files) {
                setIsSendBtnOpen(true)
                autoIncraseHeight(commentWriteBox)
            } else {
                setIsSendBtnOpen(false)
            }
        }
    }, [realTimeInputAndFilesValue])



    // photos and videos functionality-------------------------------
    const [uploadedImageFile, setUploadedImageFile] = useState<any>(null);
    const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
        // accept: 'image/*',
        accept: 'image/*,video/mp4',
        // maxFiles: 1,
        multiple: true,
        onDrop: acceptedFiles => {
            const acceptedFileWithPreviewSrc = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))

            const previewURLs: any = [];

            acceptedFileWithPreviewSrc.map(file => {
                if (file.type !== 'video/mp4') {
                    previewURLs.push({ source: file.preview, id: previewURLs.length + 1 })
                } else {
                    // getVideoCover(file.preview, 2)
                    previewURLs.push({
                        source: videoPlayerImage,
                        videoSrc: file.preview,
                        isVideoPlayOnPost: false,
                        isVideo: true,
                        id: previewURLs.length + 1,
                    })
                }
            })
            setUploadedImageFile(previewURLs)
            setRealTimeInputAndFilesValue({ textOrEmoji: realTimeInputAndFilesValue.textOrEmoji, files: previewURLs })
        }
    })





    // Comment send functionality----------------------------------
    const autoIncraseHeight = (elem: any) => {
        elem.style.height = "1px";
        elem.style.height = (elem.scrollHeight) + "px";
    }
    const [isSendBtnOpen, setIsSendBtnOpen] = useState(false)
    const [isCommentSubmitCommand, setIsCommentSubmitCommand] = useState(false)


    const handleCommentKeyboardEvent = (e: any) => {
        if (e.keyCode === 13) {
            setIsCommentSubmitCommand(true)
            if (e.shiftKey) {
                setIsCommentSubmitCommand(false)
            }
        }
        else {
            setIsCommentSubmitCommand(false)
        }
    }

    const hanldeMessageSendByInput = (e: any) => {
        setRealTimeInputAndFilesValue({ textOrEmoji: e.target.value, files: uploadedImageFile ? uploadedImageFile : null });
        let myProfileName = 'Donald Trump';
        const todayDate = new Date()
        const currentTime = todayDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
        })

        if (e.target.value.length > 0 && e.target.value.replace(/\s/g, "").length) {
            if (isCommentSubmitCommand) {
                const newMessageData = {
                    id: realtimeMessages.length + 1,
                    profilePhoto: myProfilePhoto,
                    profileName: myProfileName,
                    messageText: e.target.value,
                    messagePhotoVideo: uploadedImageFile ? uploadedImageFile : [],
                    messageSentTime: currentTime,
                    isItMyMessage: true,
                }
                const previousMessagesData = [...realtimeMessages]
                previousMessagesData.push(newMessageData);
                setRealtimeMessages(previousMessagesData)
                e.target.value = ''
                e.target.style.height = "28px";
                setRealTimeInputAndFilesValue({ textOrEmoji: '', files: null })
                setUploadedImageFile(null)
            } else {
                return
            }

        } else {
            setRealTimeInputAndFilesValue({ textOrEmoji: '', files: null })
            setUploadedImageFile(null)
            e.target.value = ''
            e.target.style.height = "28px";
        }
    }

    const hanldeCommentSendByBtn = () => {
        const messageInputBox = document.getElementById('messageWriteInput') as HTMLInputElement;

        let myProfileName = 'Donald Trump';
        const todayDate = new Date()
        const currentTime = todayDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
        })

        const previousMessagesData = [...realtimeMessages]
        const newMessageData = {
            id: realtimeMessages.length + 1,
            profilePhoto: myProfilePhoto,
            profileName: myProfileName,
            messageText: messageInputBox.value,
            messagePhotoVideo: uploadedImageFile ? uploadedImageFile : [],
            messageSentTime: currentTime,
            isItMyMessage: true,
        }

        if (messageInputBox.value.length > 0 && messageInputBox.value.replace(/\s/g, "").length) {
            setIsSendBtnOpen(true)
            previousMessagesData.push(newMessageData);
            setRealtimeMessages(previousMessagesData)
            messageInputBox.value = ''
            messageInputBox.style.height = "28px";
            setIsSendBtnOpen(false)
            setRealTimeInputAndFilesValue({ textOrEmoji: '', files: null })
            setUploadedImageFile(null)
        }
        else if (uploadedImageFile) {
            setIsSendBtnOpen(true)
            previousMessagesData.push(newMessageData);
            setRealtimeMessages(previousMessagesData)
            messageInputBox.value = ''
            messageInputBox.style.height = "28px";
            setIsSendBtnOpen(false)
            setRealTimeInputAndFilesValue({ textOrEmoji: '', files: null })
            setUploadedImageFile(null)
        }
    }





    // Emoji Picker functionality--------------------------------------------
    const messageEmojiPikcerRef = useRef(null)
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
    useClickOutside(messageEmojiPikcerRef, () => setIsEmojiPickerOpen(false))

    const hanldeEmojiSetOnComment = (e: any) => {
        const writeBoxCursorIndex = commentWriteBox.value.slice(0, commentWriteBox.selectionStart).length
        // let hex: any = e.native?.codePointAt(0)?.toString(16)
        // let emo = String.fromCodePoint(hex);
        const myOutput = commentWriteBox.value.slice(0, writeBoxCursorIndex) + e.native + commentWriteBox.value.slice(writeBoxCursorIndex, commentWriteBox.value.length)
        commentWriteBox.value = myOutput;

        commentWriteBox.selectionEnd = commentWriteBox.selectionStart = writeBoxCursorIndex + e.native.length;
        commentWriteBox.focus();
        setRealTimeInputAndFilesValue({ textOrEmoji: commentWriteBox.value, files: uploadedImageFile ? uploadedImageFile : null });
    }

    const pickerRef = React.useRef(null)
    const hanldeMyEmojiPicker = (props: any) => {
        return (
            new Picker({
                ...props, data, ref: pickerRef,
                emojiButtonRadius: '60px',
                // set: 'apple',
                theme: "dark",
                previewPosition: 'none',
                // emojiButtonSize: 35,
                // emojiSize: 20,
                // icons: 'solid',
                emojiButtonColors: [
                    'rgba(155,223,88,.7)',
                    'rgba(149,211,254,.7)',
                    'rgba(247,233,34,.7)',
                    'rgba(238,166,252,.7)',
                    'rgba(255,213,143,.7)',
                    'rgba(211,209,255,.7)',
                ],
            })
        )
    }

    useEffect(() => {
        let emojiPicker: any = document.getElementById('messageEmojiPicker');

        if (emojiPicker) {
            if (isEmojiPickerOpen) {
                const newEl = hanldeMyEmojiPicker({ onEmojiSelect: (e: any) => hanldeEmojiSetOnComment(e) })
                emojiPicker.appendChild(newEl)
            }
            else { }
        }
    }, [isEmojiPickerOpen])






    // Audio Functionality ---------------------------------
    const [isVoiceRecorderOpen, setIsVoiceRecorderOpen] = useState(false);
    const voiceRecorderRef = useRef(null)
    useClickOutside(voiceRecorderRef, () => setIsVoiceRecorderOpen(false))

    const handleRecordedVoiceSubmit = (voiceData: any) => {
        let myProfileName = 'Donald Trump';
        const todayDate = new Date()
        const currentTime = todayDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
        })

        const newMessageData = {
            id: realtimeMessages.length + 1,
            profilePhoto: myProfilePhoto,
            profileName: myProfileName,
            messageAudio: voiceData.url,
            messageSentTime: currentTime,
            isItMyMessage: true,
        }
        const previousMessagesData = [...realtimeMessages]
        previousMessagesData.push(newMessageData);
        setRealtimeMessages(previousMessagesData)
        setIsVoiceRecorderOpen(false)
    }

    // message audio
    const setVideoPlayer = (src: any) => {
        const plyrProps: any = {
            source: {
                type: 'audio',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'audio/mp3',
                        size: 720,
                        provider: 'html5',

                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                controls: ['play', 'progress', 'mute', 'volume',],
                loadSprite: true,
                tooltips: { controls: false, seek: true },
            },
        }

        return (
            plyrProps
        )
    }





    // GIFs Functionality------------------------------
    const messageGifBoxRef = useRef(null);
    const [isGifBoxOpen, setIsGifBoxOpen] = useState(false);
    useClickOutside(messageGifBoxRef, () => setIsGifBoxOpen(false))

    const handleGifOnClick = (data: any) => {
        // console.log(data);

        let myProfileName = 'Donald Trump';
        const todayDate = new Date()
        const currentTime = todayDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
        })

        const previousMessagesData = [...realtimeMessages]
        const newMessageData = {
            id: realtimeMessages.length + 1,
            profilePhoto: myProfilePhoto,
            profileName: myProfileName,
            messageGifs: data.images.preview_gif.url,
            messageSentTime: currentTime,
            isItMyMessage: true,
        }
        previousMessagesData.push(newMessageData);
        setRealtimeMessages(previousMessagesData)
        setIsGifBoxOpen(false)
        // console.log(newMessageData);

    }








    // Message uploded images preview
    const [windowWidth, setWindowWidth] = useState(1920)
    useEffect(() => {
        setWindowWidth(window.innerWidth);
    }, [])

    const [carouselDataWithOpen, setCarouselDataWithOpen] = useState({
        isOpen: false,
        image: null,
        rootData: null,
    })

    const getImageData = (clickedImageSource?: any, clickedRootData?: any) => {
        setCarouselDataWithOpen({
            isOpen: true,
            image: clickedImageSource,
            rootData: clickedRootData,
        })
    }

    const getPostGridPorps = (images: any, rootData: any) => {
        let heightNumber = [260, 220]
        let gapY = 0;

        if (images.length >= 5) {
            heightNumber = windowWidth > 640 ? [130, 120] : [100, 80]
            gapY = 2
        }
        else if (images.length === 1) {
            heightNumber = windowWidth > 640 ? [248] : [170]
        }
        else if (images.length === 2) {
            heightNumber = windowWidth > 640 ? [150] : [110]
        }
        else if (images.length === 3) {
            heightNumber = windowWidth > 640 ? [140, 120] : [100, 80]
            gapY = 2
        }
        else if (images.length === 4) {
            heightNumber = windowWidth > 640 ? [130, 130] : [110, 110]
            gapY = 2
        }

        return {
            itemsLength: images.length,
            getDataByOnClick: getImageData,
            rootData: images,
            radius: 0,
            gapX: 2,
            gapY,
            heights: heightNumber,
            images: images,
        };
    }



    return (
        <motion.div
            initial={{ right: -100, opacity: 0 }}
            animate={{ right: 0, opacity: 1 }}
            exit={{ right: -500, opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="message_inbox_main_box h-full w-full top-0 absolute overflow-hidden shadow-2xl">

            {carouselDataWithOpen.isOpen &&
                <PreviewCarousel
                    setCarouselDataWithOpen={setCarouselDataWithOpen}
                    image={carouselDataWithOpen.image}
                    rootData={carouselDataWithOpen.rootData} />
            }




            <div className="relative w-full h-full
                pb-[145px]
                xxsm:pb-[131px]
                sm:pb-[201px]">

                {/* setInboxMessagesShow */}
                <div className="xs:py-4 sm:py-10 xs:px-5 sm:px-8 w-full bg-[#e0e0e0] dark:bg-[#3B316E] flex justify-start items-start">
                    <button
                        onClick={() => props.setInboxMessagesShow({ isOpen: false, inboxData: [], })}
                        className="mr-2 mt-0.5">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 stroke-cusBlack dark:stroke-white" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                    </button>


                    <div className="text-left">
                        <h4 className="text-cusBlack dark:font-normal font-extrabold dark:text-white xs:text-lg ">UNC global Chat</h4>
                        <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xs sm:text-sm sm:mt-1">Connect & exchange your thoughts globally </p>
                    </div>
                </div>


                <div className="pt-5 xs:px-3 sm:px-6 overflow-auto scroll-smooth h-full" id="messagesBox">
                    {realtimeMessages.map((data, index) =>
                        data.isItMyMessage
                            ? <motion.div
                                initial={{ scale: 0.2, x: -10 }}
                                animate={{ scale: 1, x: 0 }}
                                exit={{ scale: 0, x: -10 }}
                                transition={{ duration: 0.2 }}
                                className="flex justify-end items-start mb-6" key={data.id}>
                                <div className="text-right mr-3 flex-1">
                                    <h4 className="text-cusBlack dark:text-white font-extrabold dark:font-semibold xs:text-sm sm:text-base">{data.profileName}</h4>
                                    <div className="flex justify-end items-start">
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs mr-2 mt-3">{data.messageSentTime}</p>
                                        <div className={`my_message_box ${data.messageAudio || data.messageGifs ? '' : 'bg-[#AB46EE] p-2 sm:p-2.5'} relative max-w-[251px] rounded-l-md rounded-b-md ml-2 mt-1.5`}>

                                            {data.messageText &&
                                                <p className="text-white text-left font-thin xs:text-xs sm:text-base break-all"
                                                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{data.messageText}</p>
                                            }

                                            {data.messageAudio &&
                                                <AudioPlayer audioPlyrProps={setVideoPlayer(data.messageAudio)} />
                                            }

                                            {data.messageGifs &&
                                                <div className="w-24 sm:w-36 h-auto rounded-lg overflow-hidden">
                                                    <img src={data.messageGifs} alt="" className="w-full h-full" />
                                                </div>
                                            }

                                            {data.messagePhotoVideo && data.messagePhotoVideo.length > 0 &&
                                                <div className={`w-[130px] xxsm:w-[201px] sm:w-[231px] rounded-md overflow-hidden ${data.messageText ? 'mt-1' : ''}`}>
                                                    <PostGrid propObject={getPostGridPorps(data.messagePhotoVideo, data.messagePhotoVideo)} />
                                                </div>
                                            }

                                            {!data.messageAudio && !data.messageGifs &&
                                                <div className="message_arrow"></div>}
                                            {/* {!data.messageGifs &&
                                                <div className="message_arrow"></div>} */}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="xs:w-8 sm:w-12 xs:h-8 sm:h-12 rounded-full ml-3">
                                        <img src={data.profilePhoto} alt="" className="w-full h-full" />
                                    </div>
                                </div>
                            </motion.div>

                            : <motion.div
                                initial={{ scale: 0.2, x: -10 }}
                                animate={{ scale: 1, x: 0 }}
                                exit={{ scale: 0, x: -10 }}
                                transition={{ duration: 0.2 }}
                                className="flex justify-start items-start mb-6" key={data.id}>
                                <div>
                                    <div className="xs:w-8 sm:w-12 xs:h-8 sm:h-12 rounded-full mr-3">
                                        <img src={data.profilePhoto} alt="" className="w-full h-full" />
                                    </div>
                                </div>

                                <div className="text-left mr-3 flex-1">
                                    <h4 className="text-cusBlack dark:text-white font-extrabold dark:font-semibold xs:text-sm sm:text-base">{data.profileName}</h4>
                                    <div className="flex justify-start items-start">
                                        <div className={`other_user_message_box 
                                        ${data.messageAudio || data.messageGifs ? '' : 'bg-[#e2e2e2] dark:bg-[#332960] p-2'}
                                         relative max-w-[245px] rounded-r-md rounded-b-md ml-2 mt-1.5`}>

                                            {data.messageText &&
                                                <p className="text-cusBlack dark:text-white text-left font-thin xs:text-xs sm:text-base break-all"
                                                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{data.messageText}</p>}

                                            {data.messageAudio &&
                                                <AudioPlayer audioPlyrProps={setVideoPlayer(data.messageAudio)} />
                                            }

                                            {data.messageGifs &&
                                                <div className="w-24 sm:w-36 h-auto rounded-lg overflow-hidden mb-2">
                                                    <img src={data.messageGifs} alt="" className="w-full h-full" />
                                                </div>
                                            }

                                            {data.messagePhotoVideo && data.messagePhotoVideo.length > 0 &&
                                                <div className={`w-[130px] xxsm:w-[201px] sm:w-[231px] rounded-md overflow-hidden ${data.messageText ? 'mt-1' : ''}`}>
                                                    <PostGrid propObject={getPostGridPorps(data.messagePhotoVideo, data.messagePhotoVideo)} />
                                                </div>
                                            }
                                            {!data.messageAudio && !data.messageGifs &&
                                                <div className="message_arrow"></div>}
                                        </div>

                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs ml-3 mt-3">{data.messageSentTime}</p>
                                    </div>
                                </div>
                            </motion.div>
                    )}
                </div>





                <div className="w-full message_write_box bg-[#e0e0e0] dark:bg-[#3B316E] absolute bottom-0 left-0">

                    <div className="flex justify-between items-start relative
                      pt-2 pl-3 pr-6 sm:pt-3 sm:pl-4 sm:pr-8">
                        {/* <input     ///Exisitng input
                            type="text"
                            name="myMessage"
                            id="MyMessageInput"
                            autoComplete="off"
                            onChange={(e) => setMessageFormValue(e.target.value)}
                            className="w-full h-full xs:p-4 sm:p-6 pr-16 text-cusBlack dark:text-white outline-none bg-transparent"
                            placeholder="Write Message…" required />
                                               */}


                        <div className="flex items-center h-fit mr-4 mt-2.5 w-full">
                            <textarea
                                name=""
                                id="messageWriteInput"
                                onChange={(e) => hanldeMessageSendByInput(e)}
                                onKeyDown={(e) => handleCommentKeyboardEvent(e)}

                                placeholder="Write Message…"
                                style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                className="w-full text-cusBlack dark:text-white outline-none bg-transparent
                                    appearance-none resize-none h-7 max-h-[160px] md:max-h-[200px] overflow-auto  text-sm xsm:text-base md:text-lg"
                            />
                        </div>


                        <div className="flex justify-end items-center h-full">
                            <AnimatePresence>
                                {isSendBtnOpen &&
                                    <motion.button
                                        initial={{ scale: 0.5, x: -10 }}
                                        animate={{ scale: 1, x: 0 }}
                                        exit={{ scale: 0, x: -10 }}
                                        type="button"
                                        onClick={hanldeCommentSendByBtn}
                                        className="mr-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 lg:w-6" viewBox="0 0 64 64" style={{ isolation: 'isolate' }}>
                                            <defs>
                                                <clipPath id="a">
                                                    <rect width={64} height={64} />
                                                </clipPath></defs><g clipPath="url(#a)">
                                                <path className="fill-[#727272] dark:fill-[#c7c6e7]" d=" M 8.216 36.338 L 26.885 32.604 C 28.552 32.271 28.552 31.729 26.885 31.396 L 8.216 27.662 C 7.104 27.44 6.021 26.356 5.799 25.245 L 2.065 6.576 C 1.731 4.908 2.714 4.133 4.259 4.846 L 61.228 31.139 C 62.257 31.614 62.257 32.386 61.228 32.861 L 4.259 59.154 C 2.714 59.867 1.731 59.092 2.065 57.424 L 5.799 38.755 C 6.021 37.644 7.104 36.56 8.216 36.338 Z " />
                                            </g>
                                        </svg>
                                    </motion.button>
                                }
                            </AnimatePresence>


                            <div
                                ref={messageEmojiPikcerRef}
                                className="mr-3 sm:relative cursor-pointer">

                                <AnimatePresence>
                                    {isEmojiPickerOpen &&
                                        <motion.div
                                            initial={{ height: 0, width: 0 }}
                                            animate={{ height: "", width: '' }}
                                            exit={{ height: 0, width: 0, opacity: 0, }}
                                            transition={{ duration: 0.3 }}
                                            className="right-0 bottom-[52px] absolute sm:bottom-8 w-full h-[40vh] sm:w-[360px] sm:h-[50vh] overflow-hidden"
                                            id="messageEmojiPicker">

                                        </motion.div>}
                                </AnimatePresence>

                                <div className="cursor-pointer" onClick={() => setIsEmojiPickerOpen(!isEmojiPickerOpen)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 lg:w-6" viewBox="0 0 20 20">
                                        <g id="Smile" transform="translate(0.349)">
                                            <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Shape" d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.22A8.806,8.806,0,1,0,16.2,3.8,8.79,8.79,0,0,0,10,1.22Z" transform="translate(-0.349)" fill="" />
                                            <circle className="fill-[#727272] dark:fill-[#c7c6e7]" id="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(5.082 6.512)" fill="" />
                                            <circle className="fill-[#727272] dark:fill-[#c7c6e7]" id="Oval-2" data-name="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(12.691 6.512)" fill="" />
                                            <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Shape-2" data-name="Shape" d="M5.789,5.61A6.044,6.044,0,0,1,.032,1.317,1.078,1.078,0,0,1,.2.415,1.023,1.023,0,0,1,1.032,0h9.512a1.054,1.054,0,0,1,.8.415,1,1,0,0,1,.171.9A5.983,5.983,0,0,1,5.789,5.61Zm0-2.2a2.556,2.556,0,0,0-1.707.659,4.569,4.569,0,0,0,1.558.3q.075,0,.15,0A4.956,4.956,0,0,0,7.5,4.049,2.7,2.7,0,0,0,5.789,3.415Zm0-1.22a3.735,3.735,0,0,1,2.8,1.268,4.933,4.933,0,0,0,1.683-2.219H1.326A4.706,4.706,0,0,0,2.983,3.463,3.687,3.687,0,0,1,5.789,2.2Z" transform="translate(4.074 10.732)" fill="" />
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            <AnimatePresence>
                                {isGifBoxOpen &&
                                    <motion.div
                                        initial={{ height: 0, width: 0 }}
                                        animate={{ height: "", width: '' }}
                                        exit={{ height: 0, width: 0, opacity: 0, }}
                                        transition={{ duration: 0.3 }}
                                        className="absolute bottom-[44px] sm:bottom-14 right-0 sm:right-8 w-full sm:w-72
                                         h-[50vh] 2xl:h-[45vh] sm:shadow-2xl sm:border-2 dark:border-[#ffffff30] border-gray-300 rounded-lg"
                                        ref={messageGifBoxRef}>

                                        <GIFs handleGifOnClick={handleGifOnClick} />

                                    </motion.div>}
                            </AnimatePresence>


                            <div className="relative cursor-pointer"
                                ref={moreAssetsRef}
                                onClick={() => setMoreAssetsOpen(!moreAssetsOpen)}>
                                <button
                                    type="button"
                                    className="mt-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="fill-[#727272] dark:fill-[#c7c6e7] w-6 lg:w-8" viewBox="0 0 20 20" fill="">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                                    </svg>
                                </button>





                                <AnimatePresence>
                                    {moreAssetsOpen &&
                                        <motion.div
                                            initial={{ height: 0, width: 0 }}
                                            animate={{ height: "auto", width: 'auto' }}
                                            exit={{ height: 0, width: 0, opacity: 0, }}
                                            transition={{ duration: 0.3 }}
                                            className="absolute bottom-8 lg:bottom-10 right-1 lg:right-2 bg-white dark:bg-[#6053a2]
                                            max-w-[200px] border-2 dark:border-[#786ac0] shadow-2xl rounded-md md:rounded-xl overflow-hidden">
                                            <button
                                                onClick={() => setIsGifBoxOpen(!isGifBoxOpen)}
                                                type="button"
                                                className="mr-4 flex justify-start items-center w-full hover:bg-[#ebebeb] dark:hover:bg-[#3b316e] px-4 py-3 transition-all">
                                                <div>
                                                    <svg id="GIF" xmlns="http://www.w3.org/2000/svg" className="w-4 sm:w-5 lg:w-6" viewBox="0 0 20.697 19.697">
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Shape" d="M14.233,19.7H6.465A6.472,6.472,0,0,1,0,13.233V6.465A6.472,6.472,0,0,1,6.465,0h7.768A6.472,6.472,0,0,1,20.7,6.465v6.768A6.472,6.472,0,0,1,14.233,19.7ZM6.465,1.163a5.308,5.308,0,0,0-5.3,5.3v6.791a5.308,5.308,0,0,0,5.3,5.3h7.768a5.308,5.308,0,0,0,5.3-5.3V6.465a5.308,5.308,0,0,0-5.3-5.3Z" transform="translate(0)" fill="" />
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V.581A.576.576,0,0,0,.581,0Z" transform="translate(11 5.651)" fill="" />
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path-2" data-name="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V4.791H4.07a.581.581,0,0,0,0-1.163H1.163V1.163H4.07A.576.576,0,0,0,4.651.581.576.576,0,0,0,4.07,0Z" transform="translate(13.512 5.651)" fill="" />
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path-3" data-name="Path" d="M3.814,1.163A2.483,2.483,0,0,1,5.791,2.256a.581.581,0,0,0,.93-.7A3.593,3.593,0,0,0,3.814,0C1.7,0,0,2,0,4.442S1.721,8.884,3.814,8.884A3.593,3.593,0,0,0,6.721,7.326a.571.571,0,0,0,.116-.349v-2.3a.581.581,0,0,0-1.163,0V6.767a2.39,2.39,0,0,1-1.86.93c-1.465,0-2.651-1.465-2.651-3.279S2.349,1.163,3.814,1.163Z" transform="translate(3 5.651)" fill="" />
                                                    </svg>
                                                </div>
                                                <p className="text-xs sm:text-sm md:text-base ml-2 text-l-LightBlack dark:text-white whitespace-nowrap">Send a GIF</p>
                                            </button>

                                            <button
                                                {...getRootProps({ className: 'messagePhotoVideoUpload' })}
                                                type="button"
                                                className="mr-4 flex justify-start items-center w-full hover:bg-[#ebebeb] dark:hover:bg-[#3b316e] px-4 py-3 transition-all">
                                                <input  {...getInputProps()} type="file" name="" id="" />
                                                <div>
                                                    <svg id="File" xmlns="http://www.w3.org/2000/svg" className="w-4 sm:w-5 lg:w-6" viewBox="0 0 21.25 19.595">
                                                        <circle className="fill-[#727272] dark:fill-[#c7c6e7]" id="Oval" cx="1.357" cy="1.357" r="1.357" transform="translate(9.054 3.595)" fill="" />
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Shape" d="M12.221,19.595H12.03l-9.619-.666a2.567,2.567,0,0,1-2.4-2.762L.959,2.4A2.638,2.638,0,0,1,3.554,0h.191L13.34.69A2.6,2.6,0,0,1,15.768,3.4l-.547,7.762-.428,6a2.569,2.569,0,0,1-.881,1.786A2.487,2.487,0,0,1,12.221,19.595Zm-8.1-9.214-2.69,2.167-.262,3.69a1.412,1.412,0,0,0,1.309,1.5l9.618.667h.1a1.433,1.433,0,0,0,.929-.334,1.331,1.331,0,0,0,.476-.952l.428-5.738-2.857-3.31-4.31,3.6.619.69a.581.581,0,0,1,.146.426.59.59,0,0,1-.194.408.649.649,0,0,1-.405.143.556.556,0,0,1-.452-.191Zm-.548-9.19A1.407,1.407,0,0,0,2.174,2.5l-.6,8.452L3.864,9.119a.586.586,0,0,1,.365-.127.6.6,0,0,1,.445.2l1.382,1.571L10.84,6.786a.59.59,0,0,1,.377-.137.617.617,0,0,1,.457.208L14.15,9.69,14.6,3.357a1.412,1.412,0,0,0-1.31-1.5L3.673,1.191Z" transform="translate(5.476)" fill="" />
                                                        <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path" d="M2.483,1.452l2.667-.214A3.888,3.888,0,0,1,5.816,0L2.387.286a2.556,2.556,0,0,0-1.762.9A2.579,2.579,0,0,0,.007,3.071L1.1,16.81a2.556,2.556,0,0,0,.9,1.762,2.582,2.582,0,0,0,1.667.619h.214L5.1,19.1l-.143-.143a4.931,4.931,0,0,1-.643-.976l-.548.048a1.428,1.428,0,0,1-1.524-1.286L1.149,3A1.462,1.462,0,0,1,2.483,1.452Z" transform="translate(0 0.095)" fill="" />
                                                    </svg>
                                                </div>
                                                <p className="text-xs sm:text-sm md:text-base ml-2 text-l-LightBlack dark:text-white whitespace-nowrap">Photo/Video</p>
                                            </button>

                                            <button
                                                onClick={() => setIsVoiceRecorderOpen(!isVoiceRecorderOpen)}
                                                type="button"
                                                className="mr-4 flex justify-start items-center w-full hover:bg-[#ebebeb] dark:hover:bg-[#3b316e] px-4 py-3 transition-all">
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-3 sm:w-3.5 lg:w-4" viewBox="0 0 13.535 21">
                                                        <g id="mic" transform="translate(-91)">
                                                            <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path_1030" data-name="Path 1030" d="M104.535,255H103.3a5.537,5.537,0,0,1-11.074,0H91a6.777,6.777,0,0,0,6.152,6.739v2.571H92.846v1.23h9.844v-1.23H98.383v-2.571A6.777,6.777,0,0,0,104.535,255Z" transform="translate(0 -244.541)" fill="" />
                                                            <path className="fill-[#727272] dark:fill-[#c7c6e7]" id="Path_1031" data-name="Path 1031" d="M155.307,14.766a4.312,4.312,0,0,0,4.307-4.307V4.307a4.307,4.307,0,0,0-8.613,0v6.152A4.312,4.312,0,0,0,155.307,14.766Zm0-13.535a3.081,3.081,0,0,1,3.014,2.461h-1.784v1.23h1.846V6.768h-1.846V8h1.846V9.844h-1.846v1.23h1.784a3.076,3.076,0,0,1-6.029,0h1.784V9.844H152.23V8h1.846V6.768H152.23V4.922h1.846V3.691h-1.784A3.081,3.081,0,0,1,155.307,1.23Z" transform="translate(-57.539)" fill="" />
                                                        </g>
                                                    </svg>
                                                </div>
                                                <p className="text-xs sm:text-sm md:text-base ml-2 text-l-LightBlack dark:text-white whitespace-nowrap">Send a Voice</p>
                                            </button>
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>



                    <div className="pb-2 pl-3 pr-6 sm:pb-4 sm:pl-4 sm:pr-8">
                        <AnimatePresence>
                            {uploadedImageFile &&
                                <motion.div
                                    initial={{ height: 0 }}
                                    animate={{ height: 'auto' }}
                                    exit={{ height: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="mt-2 w-full grid grid-cols-4 gap-x-2 gap-y-2 relative">

                                    <button
                                        onClick={() => { setUploadedImageFile(null); setRealTimeInputAndFilesValue({ textOrEmoji: realTimeInputAndFilesValue.textOrEmoji, files: null }) }}
                                        title="Close All"
                                        className="w-6 h-6 sm:w-7 sm:h-7 rounded-full absolute right-1 top-1 bg-[#72727290]
                                     border border-[#c7c6e7] flex justify-center items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:h-5 sm:w-5 stroke-[#dfd3d3] dark:stroke-white" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2.5}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>

                                    {uploadedImageFile.length > 4
                                        ? <>
                                            {uploadedImageFile.slice(0, 3).map((file: any) =>
                                                <div className="w-full h-[70px] rounded-lg overflow-hidden" key={file.id}
                                                    style={{ background: `url(${file.source})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                                </div>
                                            )}
                                            {<div className="w-full h-[70px] rounded-lg overflow-hidden"
                                                style={{ background: `url(${uploadedImageFile[3].source})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                                <div className="bg-[#00000080] w-full h-full flex justify-center items-center">
                                                    <p className="text-white text-sm md:text-lg">{uploadedImageFile.slice(4, uploadedImageFile.length).length}+</p>
                                                </div>
                                            </div>
                                            }
                                        </>
                                        : uploadedImageFile.map((file: any) =>
                                            <div className="w-full h-[70px] rounded-lg overflow-hidden" key={file.id}
                                                style={{ background: `url(${file.source})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                            </div>
                                        )
                                    }
                                </motion.div>
                            }
                        </AnimatePresence>
                    </div>
                </div>












                {/* Voice Recorder Modal */}
                <AnimatePresence>
                    {isVoiceRecorderOpen &&
                        <div
                            className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                <motion.div
                                    animate={isVoiceRecorderOpen ? "open" : "closed"}
                                    initial={{ scale: 0.7 }}
                                    variants={{
                                        open: { scale: 1 },
                                        closed: { scale: 0.9 },
                                    }}
                                    exit={{ scale: 0 }}
                                    transition={{ duration: 0.1 }}
                                    ref={voiceRecorderRef}
                                    className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left shadow-xl 
                                    transform transition-all sm:my-8 sm:align-middle sm:max-w-md lg:max-w-xl w-full">
                                    <div className="text-right pr-6 pt-5">
                                        <button onClick={() => setIsVoiceRecorderOpen(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="px-4 pt-1 pb-7 sm:pb-10 text-center">
                                        <VoiceRecorder hanldeVoiceSubmit={handleRecordedVoiceSubmit} />
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    }
                </AnimatePresence>




            </div>
        </motion.div >
    );
}
